import { useState } from 'react';
import { color } from '../../../resources/color';
import { useMutation } from '@tanstack/react-query';
import { GET, GET_REASON_CHANGE_BOOKING_DATE } from '../../../services';

export const getClaimStatusTextColor = (status) => {
  switch (status) {
    case 'WAIT':
      return color.blueFocus;
    case 'WAIT_PAYMENT':
      return color.blueFocus;
    case 'PREPARING':
      return color.blueFocus;
    case 'TRANSPORTED':
      return color.blueFocus;
    case 'REJECTED':
      return color.red;
    default:
      return color.gray;
  }
};

export const getClaimStatusBgColor = (status) => {
  switch (status) {
    case 'WAIT':
      return color.light_blue;
    case 'WAIT_PAYMENT':
      return color.light_blue;
    case 'PREPARING':
      return color.bg_yellow;
    case 'TRANSPORTED':
      return color.bg_blue;
    case 'REJECTED':
      return color.bg_red;
    default:
      return color.bg_gray;
  }
};

export const getExpCoupon = (type) => {
  return type === 'BIRTHDAY' ? 'เฉพาะในเดือนเกิด' : 'ตลอดอายุการเป็นสมาชิก 1 ปี';
};

export const useGetReasonChangeBookingDate = () => {
  const [optionsReasonChangeBookingDate, setOptionsReasonChangeBookingDate] = useState([]);
  const onFetchOptionsReasonChangeBookingDate = async () => {
    const reasonChangeBookingDateOptions = await GET(GET_REASON_CHANGE_BOOKING_DATE());
    const options = reasonChangeBookingDateOptions?.result?.items?.map((item) => ({
      label: item.optionStatusNameTh,
      value: item.optionStatusCode,
    })) || [];
    setOptionsReasonChangeBookingDate(options);
  };


  return {
    optionsReasonChangeBookingDate,
    onFetchOptionsReasonChangeBookingDate,
  };
};
